import { Dispatch } from 'redux';
import {
  fetchStatesService,
  searchBankruptcyService,
} from './Bankruptcy.services';
import {
  GetStatesSuccessType,
  SetResultLoadingType,
  GET_BAKRUPTCY_STATES_SUCCESS,
  SET_LOADING,
  RESET_RESULTS,
  ResetResultsType,
} from './Bankruptcy.types';
import {
  httpError,
  json,
  showWarnNotification,
  showSuccessNotification,
} from 'common';
import { BankruptcyStates } from './models';

const setResultLoading = (loading: boolean): SetResultLoadingType => ({
  type: SET_LOADING,
  loading,
});

const getStatesSuccess = (
  bankruptcyStates: BankruptcyStates,
): GetStatesSuccessType => ({
  type: GET_BAKRUPTCY_STATES_SUCCESS,
  bankruptcyStates,
});

export const getStates = (bearerToken: string) => (dispatch: Dispatch) => {
  dispatch(setResultLoading(true));
  fetchStatesService(bearerToken)
    .then(httpError(dispatch))
    .then(json)
    .then((response) => {
      if (response.errorMessage) throw Error(response.errorMessage);
      dispatch(getStatesSuccess(response));
      dispatch(setResultLoading(false));
    })
    .catch((error) => {
      dispatch(setResultLoading(false));
      showWarnNotification(`States`, error.message);
    });
};

export const searchBankruptcy =
  (formValues: any, exportFormat: string, token: string) =>
  (dispatch: Dispatch) => {
    const body = {
      items: formValues.items.map(
        ({
          hobCodes: { stateHob, districtCode },
          individuals,
          corporations,
        }: any) => ({
          districtCode: districtCode || stateHob,
          individuals,
          corporations,
        }),
      ),
      exportFormat,
    };
    dispatch(setResultLoading(true));
    dispatch(resetResults());
    searchBankruptcyService(body, token)
      .then(httpError(dispatch))
      .then(json)
      .then((response: any) => {
        if (response.errorMessage) throw Error(response.errorMessage);
        showSuccessNotification(
          'National Name Database',
          `Your documents will be ready soon. Please check "Recent Reports".`,
        );
        dispatch(setResultLoading(false));
      })
      .catch((error: any) => {
        showWarnNotification('National Name Database', error.message);
        dispatch(setResultLoading(false));
      });
  };

export const resetResults = (): ResetResultsType => ({
  type: RESET_RESULTS,
});
